import { InputError } from '@foodsby/nutrient'
import {
  CircularProgress,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Fade,
  Grid,
  Switch,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandMore } from '@material-ui/icons'
import React from 'react'

import { Panel } from '../common/Layout'
import PanelHeader from './PanelHeader'

/**
 * Because this expansion panel is very limited in width, we are removing the default padding.
 * This should not be a pattern followed when there is sufficient real estate available.
 */
const useStyles = makeStyles(theme => ({
  details: {
    padding: '0px',
  },
  root: {
    '&:before': {
      display: 'none',
    },
  },
  summary: {
    padding: '0px',
  },
}))

export const NotificationPreference = ({ notification, updateNotificationPreferenceStart }) => {
  const classes = useStyles()

  const handleChange = (evt, pref) => {
    updateNotificationPreferenceStart({
      channelId: notification.channel.channelId,
      enabled: evt.target.checked,
      intentId: pref.intentId,
    })
  }
  return (
    <ExpansionPanel
      className={classes.root}
      defaultExpanded={notification?.preferences?.length < 3}
      elevation={0}
      key={notification?.channel?.display}
      square
    >
      <ExpansionPanelSummary
        className={classes.summary}
        expandIcon={<ExpandMore color="primary" />}
      >
        <Typography variant="h6">{notification?.channel?.display} </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        <Grid container spacing={3}>
          {notification?.preferences?.map(pref => (
            <Grid container item key={pref?.display}>
              <Grid item xs={9}>
                <Typography variant="subtitle2">{pref.display}</Typography>
                <Typography variant="body2">{pref.description}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Switch
                  color="primary"
                  defaultChecked={pref.enabled}
                  inputProps={{ 'aria-label': `${pref.display} preference switch` }}
                  name={pref.intentType}
                  onChange={evt => handleChange(evt, pref)}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export const PanelNotificationPreferences = ({
  error,
  isLoadingNotificationPreferences,
  isUpdatingPreference,
  notificationPreferences = [],
  updateNotificationPreferenceStart,
}) => {
  const emailPreference = notificationPreferences?.find?.(np => np.channel.channelId === 1)
  return (
    <Panel>
      <PanelHeader
        headerRight={
          <Fade in={isLoadingNotificationPreferences || isUpdatingPreference}>
            <CircularProgress size={16} />
          </Fade>
        }
        title="Notification Preferences"
      />
      <NotificationPreference
        isLoadingNotificationPreferences={isLoadingNotificationPreferences}
        isUpdatingPreference={isUpdatingPreference}
        notification={emailPreference}
        updateNotificationPreferenceStart={updateNotificationPreferenceStart}
      />
      {error && (
        <InputError visible={error && error !== null}>
          Oops! Something went wrong. If this continues to happen, please contact support.
        </InputError>
      )}
    </Panel>
  )
}

export default PanelNotificationPreferences
